import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'insertHyphens',
    standalone: true,
})
export class InsertHyphensPipe implements PipeTransform {
    private stringsToBreakUpon = ['kranken', 'versicherung', 'instrumenten'];

    public transform(value: string): string {
        if (typeof value !== 'string') {
            return null;
        }
        let newValue = value;
        for (const toBreakUpon of this.stringsToBreakUpon) {
            newValue = newValue.replaceAll(toBreakUpon, '&shy;' + toBreakUpon);
        }
        return newValue;
    }
}
